import { Marker } from "react-map-gl";
import PropTypes from 'prop-types';

const MapMarker = (props) => {
	return (
		<Marker {...props}>
			<div style={{background: 'red', borderRadius:'100%', border: '1px solid black', width: '15px', height: '15px'}}></div>
		</Marker>
	)
}

MapMarker.propTypes = {
	//for other props check https://visgl.github.io/react-map-gl/docs/api-reference/marker
	color: PropTypes.string,
	style: PropTypes.object,
	longitude: PropTypes.number,
	latitude: PropTypes.number,
}

MapMarker.defaultProps = { }

export default MapMarker;